import ColumnSet from '@/components/grid/columns/column-set';
import store from '@/store';
import _ from '@/common/helpers';
import auth from '@/common/auth/auth';

export default function createColumns(showDeleteAPIKeyDialog, copyAPIKey) {
    return new ColumnSet({
        id: 'api-keys-list',
        store,
        version: 7,
        defaultColumns: [
            {
                header: 'Name',
                name: 'description',
                type: 'link',
                to: ({fields}) => ({
                    name: 'update-api-key',
                    params: {id: fields.id},
                }),
                sticky: true,
            },
            {
                name: 'type',
                sortable: true,
                value: fields => _.capitalize(fields.type),
            },
            {
                name: 'secretKey',
                sortable: true,
                style: {blur: true},
                copy: ({rowData}) => copyAPIKey(rowData),
            },
            {
                header: 'Created On',
                name: 'createdTime',
                type: 'datetime',
                sortable: true,
            },
        ],
        otherColumns: [
            {
                name: 'id',
                style: {truncate: true},
                sortable: true,
            },
            {
                name: 'apiUser',
                sortable: true,
            },
            {
                name: 'datetimeFormat',
                sortable: true,
            },
        ],
        lockedColumns: [
            {
                header: false,
                type: 'button',
                style: {
                    preset: 'delete',
                    tooltip: 'delete',
                },
                click: ({rowData, grid}) => {
                    showDeleteAPIKeyDialog(rowData, grid);
                },
                predicate: auth.$pages['update-api-key'].isAllowed,
            },
        ],
    });
}
